export default "__VITE_ASSET__9c0d5142__"